import moment from 'moment';
import { useDispatch } from 'react-redux';
import { hideConfirmCandidateAnotherJobPopup } from '~/actions';
import { Typography } from '@tempmee/react';
import {
  Box,
  Center,
  Checkbox,
  Checkcircle,
  Column,
  Pressable,
  Row,
} from '~/commonComponents';
import { IJob } from '~/domain/Jobs';
import history from '~/browserHistory';
import ChevronRight from '~/images/arrow_right.svg';
import { IUser } from '~/models';
import { ShiftListSelectionMode } from './enums';

interface IProps {
  candidate: IUser;
  isChecked: boolean;
  job: IJob;
  mode: ShiftListSelectionMode;
  handleToggleOption: (jobId?: string) => void;
}

export const ShiftItem = ({
  candidate,
  isChecked = false,
  job,
  mode,
  handleToggleOption,
}: IProps) => {
  const dispatch = useDispatch();
  const { multipleCounters } = job;
  const offerCounter = multipleCounters.find((counter) => counter.candidate.id === candidate?.id)!;

  const hasCounterHours =
    offerCounter?.begin !== offerCounter?.originalBegin ||
    offerCounter?.end !== offerCounter?.originalEnd;
  const hasCounterRates = offerCounter?.rate !== offerCounter?.originalRate;

  return (
    <Row className="shift-item" height={64}>
      <Pressable
        style={{
          width: '10%',
        }}
        onPress={() => handleToggleOption(job.id)}
      >
        <Center height={64} flex={1}>
          {mode === ShiftListSelectionMode.Multiple ? (
            <Checkbox checked={isChecked} />
          ) : (
            <Checkcircle checked={isChecked} />
          )}
        </Center>
      </Pressable>
      <Pressable
        style={{
          flex: 1,
        }}
        onPress={() => {
          dispatch(hideConfirmCandidateAnotherJobPopup());
          history.push(`/dashboard/candidates/${offerCounter.candidate.id}/jobs/${job.id}`, {
            fromBulkConfirmation: true,
          });
        }}
      >
        <Row height={64} flex={1} alignItems="center">
          <Box flex={1}>
            <Typography as="span">{moment(job?.jobDatetime).format('ddd, MMM DD, YYYY')}</Typography>
          </Box>
          <Column flex={1}>
            <Typography as="span" bold>{job?.professionName}</Typography>
            <Typography as="span">{job?.profession}</Typography>
          </Column>
          <Column flex={1}>
            <Typography as="span" style={{ textDecoration: hasCounterHours ? 'line-through' : 'none' }}>
              {job.localStartTime} - {job.localEndTime}
            </Typography>
            {hasCounterHours && (
              <Typography as="span" bold>
                {offerCounter?.local_begin} - {offerCounter?.local_end}
              </Typography>
            )}
          </Column>
          <Column flex={1}>
            <Typography as="span" style={{ textDecoration: hasCounterRates ? 'line-through' : 'none' }}>
              {`$${offerCounter?.originalRate?.toFixed(2)}`}
            </Typography>
            {hasCounterRates && <Typography as="span" bold>{`$${offerCounter?.rate?.toFixed(2)}`}</Typography>}
          </Column>
          <Box flex={1}>
            <Typography as="span" bold>{`$${job?.total?.toFixed(2)}`}</Typography>
          </Box>
          <Center width={'11.2%'}>
            <img src={ChevronRight} alt="arrow" style={{ width: 16, height: 16 }} />
          </Center>
        </Row>
      </Pressable>
    </Row>
  );
};
